import { render } from "./TheBreadcrumb.vue?vue&type=template&id=22e1db7c&scoped=true&lang=pug"
import script from "./TheBreadcrumb.vue?vue&type=script&lang=js"
export * from "./TheBreadcrumb.vue?vue&type=script&lang=js"

import "./TheBreadcrumb.vue?vue&type=style&index=0&id=22e1db7c&lang=scss&scoped=true"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e1db7c"]])

export default __exports__